import React from 'react'

export default function BenefitRow({ text, iconSrc }) {
  const src = iconSrc || undefined

  return (
    <div className="AutoTrafficFineNotificationPackageInfo_benefit-row">
      <img
        src={src}
        alt=""
        className={src ? 'AutoTrafficFineNotificationPackageInfo_benefit-icon' : 'AutoTrafficFineNotificationPackageInfo_benefit-icon is-hidden'}
        onError={(e) => {
          e.currentTarget.style.display = 'none'
        }}
      />
      <div className="AutoTrafficFineNotificationPackageInfo_benefit-text">{text}</div>
    </div>
  )
}
